package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.SubscribeButtonStyle
import org.jetbrains.compose.web.css.*

@Composable
fun AuthRequiredPopup(
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val pageBg     = if (isDark) io.horion.cv.utils.Colors.DarkBG   else io.horion.cv.utils.Colors.White
    val titleColor = if (isDark) io.horion.cv.utils.Colors.White     else io.horion.cv.utils.Colors.NightBlue
    val iconFilter = if (isDark) "none" else "invert(0.8)"

    Overlay(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(Color.rgba(0, 0, 0, 0.7f))
            .onClick { onDismiss() },
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .width(400.px)
                .backgroundColor(pageBg)
                .borderRadius(20.px)
                .padding(32.px)
                .onClick { it.stopPropagation() }
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                // Icône Verrou ou Utilisateur


                SpanText(
                    "Connexion requise",
                    modifier = Modifier
                        .fontSize(22.px)
                        .fontWeight(FontWeight.Bold)
                        .color(titleColor)
                )

                Box(Modifier.height(12.px))

                SpanText(
                    "Vous devez être connecté pour télécharger ou enregistrer sur votre compte.",
                    modifier = Modifier
                        .fontSize(15.px)
                        .color(titleColor)
                        .textAlign(TextAlign.Center)
                )

                Box(Modifier.height(32.px))

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(12.px)
                ) {
                    // Bouton Annuler
                    Button(
                        onClick = {onDismiss()},
                        modifier = SubscribeButtonStyle.toModifier()
                            .weight(1f)
                            .height(45.px)
                            .borderRadius(10.px)
                            .backgroundColor(Colors.Transparent)
                            .border(1.px, LineStyle.Solid, titleColor)
                    ) {
                        SpanText("Plus tard", modifier = Modifier.color(titleColor))
                    }

                    // Bouton Connexion
                    Button(
                        onClick = {onConfirm()},
                        modifier = SubscribeButtonStyle.toModifier()
                            .weight(1f)
                            .height(45.px)
                            .borderRadius(10.px)
                            .backgroundColor(Color.rgb(0x3B, 0x82, 0xF6)) // Bleu
                    ) {
                        SpanText("Se connecter", modifier = Modifier.color(titleColor).fontWeight(FontWeight.Bold))
                    }
                }
            }
        }
    }
}